import './GaugeChartLayout.css';
export var layoutContainer = '_ezp7cy0-3-5-0';